import { Faculty } from "./types";

export const determineIfCourseHasLab = (
  courseTitle: string,
  allFacultyData: Faculty[]
): boolean => {
  const courseTheoryEntry = allFacultyData.find(
    (faculty) => faculty.TITLE.toLowerCase() === courseTitle.toLowerCase()
  );

  if (!courseTheoryEntry) {
    return false;
  }

  const { CODE, TYPE } = courseTheoryEntry;

  if (TYPE === "SS") {
    return false;
  }

  if (TYPE === "ETH") {
    return true;
  }

  if (TYPE === "TH") {
    if (CODE.endsWith("L")) {
      const baseCode = CODE.slice(0, -1);
      const labCode = `${baseCode}P`;
      return allFacultyData.some(
        (faculty) => faculty.CODE === labCode && faculty.TYPE === "LO"
      );
    }
  }

  return false;
}; 